/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { currencyFormatter } from '../../../../utils/formatting';

const ExchangeInTender = ({ transaction }) => {
  const {
    isAdmin, locale: { storeCurrency, storeLocale },
    GiftCard, RL_CardNo, RL_ExchangeInTender, RL_Balance, RL_AuthCode, RL_StoreCredit, redacted,
  } = useSelector((state) => state);
  const sortedValue = transaction?.TenderControlTransaction?.StoredValueTransaction;

  return (
    <>
      <article className="justify-between"><p>{RL_ExchangeInTender}</p></article>
      {['StoreCredit', 'GiftCertificate'].includes(sortedValue?.StoredValueFunds[0]?.TypeCode) && (
        <>
          <article className="justify-between">
            <p className="pl2-sm">{sortedValue?.StoredValueFunds[0]?.TypeCode === 'StoreCredit' ? RL_StoreCredit : 'Gift Certificate'}</p>
            <p>
              {currencyFormatter(
                storeLocale,
                storeCurrency,
                sortedValue?.StoredValueFunds?.map((item) => item.Instruments.map((amount) => amount.FaceValueAmount.Amount)),
              )}
            </p>
          </article>
          <br /><br />
        </>
      )}
      {(sortedValue?.StoredValueFunds[0]?.TypeCode === 'GiftCard') && (
      <>
        <article className="justify-between">
          <p className="pl2-sm">{GiftCard}</p>
          <p>
            {currencyFormatter(
              storeLocale,
              storeCurrency,
              sortedValue?.StoredValueFunds?.map((item) => item.Instruments.map((amount) => amount.FaceValueAmount.Amount)),
            )}
          </p>
        </article>
        <article className="justify-between">
          <p className="pl2-sm">{RL_AuthCode}</p>
          <p className="pr2-sm">{sortedValue?.Tender?.GiftCard?.Authorization?.AuthorizationCode}</p>
        </article>
        <article className="justify-between">
          <p className="pl2-sm">{RL_CardNo}</p>
          <p className="pr2-sm">{isAdmin ? (sortedValue?.Tender?.GiftCard?.CardNumber?.replace(/.(?=.{4})/g, 'X') || '') : redacted}</p>
        </article>
        <article className="justify-between">
          <p className="pl2-sm">{RL_Balance}</p>
          <p>
            {currencyFormatter(
              storeLocale,
              storeCurrency,
              sortedValue?.Tender?.GiftCard?.CurrentBalance?.Amount,
            )}
          </p>
        </article>
        <br /><br />
      </>
      )}
    </>
  );
};

ExchangeInTender.defaultProps = {
  transaction: {},
};

ExchangeInTender.propTypes = {
  transaction: PropTypes.shape(),
};

export default ExchangeInTender;
